import { render } from "./ConsultaProdutosPorEndereco.vue?vue&type=template&id=654998da&scoped=true"
import script from "./ConsultaProdutosPorEndereco.vue?vue&type=script&lang=js"
export * from "./ConsultaProdutosPorEndereco.vue?vue&type=script&lang=js"

import "./ConsultaProdutosPorEndereco.vue?vue&type=style&index=0&id=654998da&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-654998da"]])

export default __exports__